import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { OutlinedInput } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';
import axiosInstance, { EVENT_ID, WEB_API } from '../constatns';
import queryString from 'query-string';
const styles = (theme) => ({
  root: {
    overflowX: 'hidden',
    overflowY: 'hidden',
    width: '100%',
  },
  title2: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  OutlinedInput: {
    width: '100%',
    padding: '5px 7px',
    '& .MuiOutlinedInput-input': {
      padding: '4px 10px',
    },
    '& *': {
      border: 'none',
    },
  },

  btn: {
    padding: '5px 7px',
  },
});

class ConfirmSignup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      name_kor: '',
      firstName: '',
      lastName: '',
      license: '',
      title: '',
      titleOthers: '',
      department: '',
      kind: '',
      postalCode: '',
      address: '',
      addressEn: '',
      city: '',
      position: '',
      positionEn: '',
      hp1: '',
      hp2: '',
      hp3: '',
      hp4: '',
      tel1: '',
      tel2: '',
      tel3: '',
      tel4: '',
      etc: '',
      country: '',
    };
    this.goToPage = this.goToPage.bind(this);

    this.getSignupInfo = this.getSignupInfo.bind(this);
  }

  componentDidMount() {
    if (
      window.screen.width < 500 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      this.setState({ matches: true });
    } else {
      this.setState({ matches: false });
    }
    if (this.props.location.state) {
      this.getSignupInfo();
    } else {
      this.getInfofromDB();
    }
    this.setState({ lang: queryString.parse(this.props.location.search)['lang'] || 'kor' });

    //console.log(this.state);
  }
  getSignupInfo() {
    if (this.props.location.state) {
      const searchQuery = queryString.parse(this.props.location.search);
      this.setState({ lang: searchQuery['lang'] || 'kor', data: this.props.location.state.userInfo }, () => {
        const data = this.state.data;
        console.log(data, 'data');
        this.setState({
          email: data.email,
          name_kor: data.name_kor,
          name_eng: data.firstName + ' ' + data.lastName,
          lastName: data.email,
          license: data.license,
          title: data.title,
          titleOthers: data.titleOthers,
          // department: data.department,
          department: data.dept,
          kind: data.kind,
          postalCode: data.name_kor_r,
          address: data.address,
          addressEn: data.addressEn,
          city: data.city,
          position: data.position,
          positionEn: data.positionEn,
          hp: '+' + data.hp1 + ' ' + data.hp2 + ' ' + data.hp3 + ' ' + data.hp4,
          tel: '+' + data.tel1 + ' ' + data.tel2 + ' ' + data.tel3 + ' ' + data.tel4,
          etc: data.etc,

          country: data.country,
        });
      });
    }
  }
  getInfofromDB() {
    if (sessionStorage.getItem('_in_user_')) {
      axiosInstance
        .get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${EVENT_ID}_${queryString.parse(this.props.location.search)['email']}`)
        .then((response) => {
          //console.log(response.data.Item);
          this.setState(
            {
              lang: queryString.parse(this.props.location.search)['lang'],
              data: response.data.Item,
            },
            () => {
              const data = this.state.data;
              console.log(data);
              this.setState({
                email: data.email,
                name_kor: data.username,
                name_eng: data.firstName + ' ' + data.lastName,
                lastName: data.email,
                license: data.license,
                title: data.title,
                titleOthers: data.titleOthers,
                department: data.dept,
                kind: data.kind,
                postalCode: data.postalCode,
                address: data.address,
                addressEn: data.addressEn,
                city: data.address,
                position: data.position,
                positionEn: data.positionEn,
                hp: data.hp,
                tel: data.tel,
                etc: data.etc,

                country: data.country,
              });
            },
          );
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.props.history.push('/main');
    }
  }
  goToPage(_move) {
    this.props.history.push(_move);
  }

  render() {
    const { classes, theme } = this.props;
    const { lang } = this.state;
    return (
      <React.Fragment>
        <CssBaseline />
        <Topbar MIdx={6} SIdx={6} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8} container>
              <MainTitle>Sign-Up</MainTitle>
            </Grid>
            <Grid item xs={8} container justifyContent="center" alignItems="center" style={{ padding: '15px', marginBottom: 50 }}>
              {/* <img src="/images/prs2021/applycom.png" alt="" /> */}
              <div style={{ width: 70, height: '100%' }} />
              <div>
                <p style={{ fontSize: 30, marginBottom: '20px', fontWeight: 'bold', color: this.props.theme.palette.primary.main }}>
                  Welcome to PRS KOREA 2022
                </p>
                {/* <p style={{ fontSize: 25, textAlign: 'center' }}>Please log-in</p> */}
              </div>
            </Grid>
            {/* <TableContainer component={Paper} style={{ marginBottom: '10vh' }}> */}
            <Grid item xs={8}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell component={'th'} align="center">
                      <b>Country</b>
                    </TableCell>
                    <TableCell align="center">
                      {/* <OutlinedInput required className={classes.OutlinedInput} value="Korea, Republic of" /> */}
                      <OutlinedInput required className={classes.OutlinedInput} value={this.state.country} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'} align="center">
                      <b>
                        <span>*&nbsp;</span>ID(E-mail){' '}
                      </b>
                    </TableCell>

                    <TableCell align="center">
                      <OutlinedInput readOnly required className={classes.OutlinedInput} value={this.state.email} />
                    </TableCell>
                  </TableRow>
                  {lang === 'kor' && this.state.kind !== '국내연수 외국인의사' ? (
                    <TableRow>
                      <TableCell component={'th'} align="center">
                        <b>
                          <span>*&nbsp;</span>성명(국문)
                        </b>
                      </TableCell>

                      <TableCell align="center">
                        <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.name_kor} />
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow>
                    <TableCell component={'th'} align="center">
                      <b>
                        <span>*&nbsp;</span>
                        {lang === 'kor' ? '성명(영문)' : 'Name'}
                      </b>
                    </TableCell>

                    <TableCell align="center">
                      <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.name_eng} />
                    </TableCell>
                  </TableRow>
                  {lang === 'kor' && this.state.kind !== '국내연수 외국인의사' && this.state.kind !== '동반자' ? (
                    <TableRow>
                      <TableCell component={'th'} align="center">
                        <b>
                          <span>*&nbsp;</span>의사면허번호
                        </b>
                      </TableCell>

                      <TableCell align="center">
                        <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.license} />
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow>
                    <TableCell component={'th'} align="center">
                      <b>
                        <span>*&nbsp;</span>Title
                      </b>
                    </TableCell>

                    <TableCell align="center">
                      <OutlinedInput
                        readOnly
                        className={classes.OutlinedInput}
                        value={this.state.title !== 'Others' ? this.state.title : this.state.titleOthers}
                      />
                    </TableCell>
                  </TableRow>
                  {lang === 'kor' ? (
                    <TableRow>
                      <TableCell component={'th'} align="center">
                        <b>
                          <span>*&nbsp;</span>구분
                        </b>
                      </TableCell>
                      <TableCell align="center">
                        <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.kind} />
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}
                  {this.state.kind === '동반자' || this.state.kind === '국내연수 외국인의사' ? (
                    <>
                      <TableRow>
                        <TableCell component={'th'} rowSpan={2} align="center">
                          <b>
                            <span>*&nbsp;</span>추천인
                          </b>
                        </TableCell>
                        <TableCell>
                          <OutlinedInput readOnly className={classes.OutlinedInput} value={'추천인: ' + this.state.data['name_kor_r']} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <OutlinedInput readOnly className={classes.OutlinedInput} value={'의사면허번호: ' + this.state.license} />
                        </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    ''
                  )}
                  <TableRow>
                    <TableCell component={'th'} align="center">
                      <b>
                        <span>*&nbsp;</span>
                        {lang === 'kor' ? '소속(근무처)' : 'Affiliation'}
                      </b>
                    </TableCell>

                    <TableCell align="center">
                      {lang === 'kor' ? (
                        <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '10px' }}>
                          <OutlinedInput readOnly className={classes.OutlinedInput} value={`국문: ${this.state.position}`} />
                        </Grid>
                      ) : (
                        ''
                      )}

                      <Grid container justifyContent="space-between" alignItems="center">
                        <OutlinedInput
                          readOnly
                          className={classes.OutlinedInput}
                          value={lang === 'kor' ? '영문: ' + this.state.positionEn : this.state.positionEn}
                        />
                      </Grid>
                    </TableCell>
                  </TableRow>
                  {lang === 'eng' && (
                    <TableRow>
                      <TableCell component={'th'} align="center">
                        <b>
                          <span>*&nbsp;</span>
                          Department
                        </b>
                      </TableCell>
                      <TableCell align="center">
                        <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.department} />
                      </TableCell>
                    </TableRow>
                  )}

                  {/* <TableRow>
                    <TableCell component={'th'} align="center">
                      <b>
                        <span>*&nbsp;</span> {lang === 'kor' ? '주소' : 'Address'}
                      </b>
                    </TableCell>
                    <TableCell align="center">
                      {lang === 'kor' ? (
                        <>
                          <Grid container style={{ marginBottom: '10px' }}>
                            <OutlinedInput
                              readOnly
                              className={classes.OutlinedInput}
                              style={{ marginRight: '10px' }}
                              value={this.state.postalCode}
                            />
                          </Grid>
                          <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '10px' }}>
                            <OutlinedInput readOnly className={classes.OutlinedInput} value={`국문: ${this.state.address}`} />
                          </Grid>
                        </>
                      ) : (
                        ''
                      )}

                      <Grid container justifyContent="space-between" alignItems="center">
                        <OutlinedInput
                          readOnly
                          className={classes.OutlinedInput}
                          value={lang === 'kor' ? '영문: ' + this.state.addressEn : this.state.addressEn}
                        />
                      </Grid>
                    </TableCell>
                  </TableRow>
                  {lang === 'eng' && (
                    <TableRow>
                      <TableCell component={'th'} align="center">
                        <b>
                          <span>*&nbsp;</span>
                          City
                        </b>
                      </TableCell>
                      <TableCell align="center">
                        <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.city} />
                      </TableCell>
                    </TableRow>
                  )} */}
                  <TableRow>
                    <TableCell component={'th'} align="center">
                      <b>
                        <span>*&nbsp;</span>
                        {lang === 'kor' ? '핸드폰 번호' : 'Phone'}
                      </b>
                    </TableCell>

                    <TableCell align="center">
                      <div>
                        <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.hp} />
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'} align="center">
                      <b> {lang === 'kor' ? '전화번호' : 'Telephone'}</b>
                    </TableCell>

                    <TableCell align="center">
                      <div>
                        <Grid container justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
                          {this.state.tel !== '+' && <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.tel} />}
                        </Grid>
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'} align="center">
                      <b>{lang === 'kor' ? '기타사항' : 'Remark'}</b>
                    </TableCell>
                    <TableCell align="center">
                      <OutlinedInput readOnly className={classes.OutlinedInput} value={this.state.etc} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            {/* </TableContainer> */}
            <Grid item xs={8} container justifyContent="center" alignitems="center" style={{ margin: theme.spacing(5, 0, 10) }}>
              <ConfirmButton
                // variant="contained"
                // style={{ width: '150px', fontSize: '20px', marginRight: '20px', fontWeight: 'bold' }}
                onClick={() => this.props.history.push('/signin')}
                color="primary"
              >
                Login
              </ConfirmButton>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(ConfirmSignup));
